export enum FeatureFlagEndpoints {
    BASE = '/feature-flags',
    ACCESS = '/feature-flags/access',
    GROUPS = '/feature-flags/groups',
}

export const FEATURE_FLAGS_QUERY_KEYS = {
    all: ['feature-flags'] as const,
    list: (page: number, limit: number) => ['feature-flags', 'list', page, limit] as const,
    keys: ['feature-flags', 'keys'] as const,
    detail: (key: string) => ['feature-flags', 'detail', key] as const,
    access: (keys: string[]) => ['feature-flags', 'access', ...keys] as const,
    groups: ['feature-flags', 'groups'] as const,
} as const;

/**
 * No FE caching for feature flags: access resolution is cached on the backend.
 * TanStack + service layer always refetch so admin changes propagate immediately.
 */
export const FEATURE_FLAGS_QUERY_CONFIG = {
    STALE_TIME: 0,
    GC_TIME: 0,
} as const;

export const FEATURE_FLAGS_DEFAULTS = {
    PAGE: 1,
    LIMIT: 25,
    MAX_LIMIT: 100,
} as const;
